<template>
  <section class="mx-5 mt-2 lg:mt-6">
    <slot />
  </section>
</template>

<script lang="ts">
export default defineComponent({
  name: 'PageContent',
})
</script>
